import { createSlice } from '@reduxjs/toolkit';
import { setLocalStorage } from '../../helpers/jsHelper';
import { REQUEST_DATA } from '../../config/constant/projectConstant';

// const _intial_data = getLocalStorage(REQUEST_DATA);

const setData = (state, data) => {
  state.activeTab = data.activeTab;
  state.currentRequestId = data.currentRequestId;
  state.currentRequestCategory = data.currentRequestCategory;
  state.currentRequestFilesSize = data.currentRequestFilesSize;
  state.currentRequestPageId = data.currentRequestPageId;
  state.currentRequestSubPageId = data.currentRequestSubPageId;
  state.currentPage = data.currentPage;
  state.filesUploadProgress = data.filesUploadProgress;
  state.filesUploadStatus = data.filesUploadStatus;
  state.hasCustomizableparts = data.hasCustomizableparts;
  state.hasNoModelLeft = data.hasNoModelLeft;
  state.hideSideBar = data.hideSideBar;
  state.isNextButtonEnabled = data.isNextButtonEnabled;
  state.purchasedInfo = data.purchasedInfo;
  state.requestData = data.requestData;
  state.requestName = data.requestName;
  state.requestPages = data.requestPages;
  state.submitButtonTitle = data.submitButtonTitle;
  state.loading = data.loading;
  state.showImagesPage = data.showImagesPage;

};


const _requestPages = [
  { id: 1, name: 'Name', goNextTo: 2, goBackTo: null },
  {
    id: 2,
    name: 'Type',
    goNextTo: 3,
    goBackTo: 1,
  },
  { id: 3, name: 'Images', showSkipButton: true, goNextTo: 4, goBackTo: 2 },
  { id: 4, name: 'Size', showSkipButton: true, goNextTo: 5, goBackTo: 3 },
  { id: 5, name: 'Parts', showSkipButton: true, goNextTo: 6, goBackTo: 4, skipSubPageOnBack: true },
  { id: 6, name: 'Finishes', showSkipButton: true, goNextTo: 7, goBackTo: 5 },
  { id: 7, name: 'Notes', goNextTo: null, goBackTo: 6 },
];

const initialRequestState = {
  isNextButtonEnabled: false,
  requestPages: _requestPages,
  currentRequestPageId: 1,
  currentRequestSubPageId: null,
  currentRequestId: null,
  submitButtonTitle: 'Next',
  currentPage: _requestPages[0],
  hideSideBar: false,
  requestName: '',
  requestData: '',
  hasCustomizableparts: true,
  showImagesPage: true,
  hasNoModelLeft: false,
  currentRequestCategory: '',
  currentRequestFilesSize: 0,
  activeTab: 'product',
  loading: false,
  purchasedInfo: null,
  playRequestVideo: false,
};

const requests = createSlice({
  name: 'requests',
  initialState: initialRequestState,
  reducers: {
    setNextButtonEnabled: (state, { payload }) => {
      state.isNextButtonEnabled = payload;
    },

    updateRequestPages: (state, { payload }) => {
      const updatedRequest = state.requestPages.filter((item) => item.id === payload.id)[0];

      var index = state.requestPages.indexOf(updatedRequest);

      if (index !== -1) {
        state.requestPages[index] = payload;
      }

      // setLocalStorage(REQUEST_DATA, setData(state));
    },

    setAllRequestData: (state, { payload }) => {
      setData(state, payload);
    },

    setRequestPages: (state, { payload }) => {
      state.requestPages = payload;
    },

    setCurrentRequestPageId: (state, { payload }) => {
      state.currentRequestPageId = payload;
    },

    setCurrentRequestSubPageId: (state, { payload }) => {
      state.currentRequestSubPageId = payload;
    },

    setRequestData: (state, { payload }) => {
      state.requestData = payload;
    },

    setRequestName: (state, { payload }) => {
      state.requestName = payload;
    },

    setCurrentRequestCategory: (state, { payload }) => {
      state.currentRequestCategory = payload;
    },
    setSelectedProduct: (state, { payload }) => {
      state.selectedProduct = payload;
    },

    setSubmitButtonTitle: (state, { payload }) => {
      state.submitButtonTitle = payload;
    },

    setHideSideBar: (state, { payload }) => {
      state.hideSideBar = payload;
    },

    setCurrentRequestId: (state, { payload }) => {
      state.currentRequestId = payload;
    },

    setShowImagesPage: (state, { payload }) => {
      state.showImagesPage = payload;
    },
    setHasCustomizableParts: (state, { payload }) => {
      state.hasCustomizableparts = payload;
    },
    setHasNoModelLeft: (state, { payload }) => {
      state.hasNoModelLeft = payload;
    },
    setWindowSize: (state, { payload }) => {
      state.windowSize = payload;
    },
    setFilesUploadProgress: (state, { payload }) => {
      state.filesUploadProgress = { ...state.filesUploadProgress, ...payload };
    },
    setFilesUploadStatus: (state, { payload }) => {
      state.filesUploadStatus = { ...state.filesUploadStatus, ...payload };
    },
    setNextButtonToolTip: (state, { payload }) => {
      state.nextButtonToolTip = payload;
    },
    setNextButtonHovered: (state, { payload }) => {
      state.nextButtonHovered = payload;
    },
    setCurrentRequestFilesSize: (state, { payload }) => {
      state.currentRequestFilesSize = payload;
    },
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload;
    },
    setPurchasedInfo: (state, { payload }) => {
      state.purchasedInfo = payload;
    },
    resetState: (state) => {
      return {
        ...initialRequestState,
      };
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setPlayRequestVideo: (state, { payload }) => {
      state.playRequestVideo = payload;
    },
  },
});

export const getCurrentPage = (state) => {
  return state?.requests?.requestPages?.find(
    (item) => item.id === state.requests.currentRequestPageId
  );
};

export const hideSideBar = (state) => {
  return state.requests.hideSideBar;
};

export const {
  setRequestPages,
  setNextButtonEnabled,
  updateRequestPages,
  setCurrentRequestPageId,
  setRequestData,
  setAllRequestData,
  setRequestName,
  setCurrentRequestSubPageId,
  setCurrentRequestCategory,
  setSelectedProduct,
  setSubmitButtonTitle,
  setHideSideBar,
  setCurrentRequestId,
  setShowImagesPage,
  setHasNoModelLeft,
  setFilesUploadProgress,
  setFilesUploadStatus,
  setNextButtonToolTip,
  setCurrentRequestFilesSize,
  setActiveTab,
  resetState,
  setHasCustomizableParts,
  setNextButtonHovered,
  setLoading,
  setPurchasedInfo,
  setPlayRequestVideo,
} = requests.actions;
export const requestsSelector = (state) => state.requests;
export const requestsReducer = requests.reducer;
export default requestsReducer;
